import { render, staticRenderFns } from "./VariantDialog.vue?vue&type=template&id=6fd85720&scoped=true"
import script from "./VariantDialog.vue?vue&type=script&lang=js"
export * from "./VariantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd85720",
  null
  
)

export default component.exports